import { cn } from "@/utils/cn";

type Props = {
  categories: string[];
  selected: string | null;
  onSelect: (c: string | null) => void;
};

export function CategoryFilter({ categories, selected, onSelect }: Props) {
  return (
    <div
      role="radiogroup"
      aria-label="Filter by category"
      className="flex flex-wrap gap-2"
    >
      <Pill active={selected === null} onClick={() => onSelect(null)}>
        All
      </Pill>
      {categories.map((c) => (
        <Pill key={c} active={selected === c} onClick={() => onSelect(c)}>
          {c}
        </Pill>
      ))}
    </div>
  );
}

function Pill({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={active}
      onClick={onClick}
      className={cn(
        "rounded-full border px-3 py-1 text-xs font-medium transition",
        active
          ? "border-brand-500 bg-brand-500 text-white"
          : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50",
      )}
    >
      {children}
    </button>
  );
}
